import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, extend, fetch2 } from '../utils';
import Searcher from './Searcher';
import { reproject, reverse } from 'reproject';
import { geojsonPrecision } from '../util/geojson-precision';
export default Class(Searcher, {
  defaults: {
    serviceUrl: 'https://otp.septima.dk/septima-OO47AF6JEX/otp/routers/denmark/isochrone',
    mode: 'CAR',
    modetext: 'kørsel',
    date: '11-14-2017',
    time: '8:00am',
    precisionMeters: 100,
    maxWalkDistance: 10,
    cutoffSecs: [120, 240, 360, 480],
    source: 'fama.septima.dk',
    type: "isochrone",
    iconURI: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMywxQzEuODksMSAxLDEuODkgMSwzVjE0QzEsMTUuMTEgMS44OSwxNiAzLDE2SDdWMjBDNywyMS4xMSA3Ljg5LDIyIDksMjJIMjBDMjEuMTEsMjIgMjIsMjEuMTEgMjIsMjBWOUMyMiw3Ljg5IDIxLjExLDcgMjAsN0gxNlYzQzE2LDEuODkgMTUuMTEsMSAxNCwxSDNNMywzSDE0VjlIMjBWMjBIOVYxNEgzVjNaIiAvPjwvc3ZnPg=="
  },
  initialize: function initialize(searcherOptions) {
    this.options = searcherOptions ? searcherOptions : {};
    this.options.usesGeoFunctions = true;
    this.options = extend(this.defaults, this.options);
    this.iconURI = this.options.iconURI;
    this.Searcher(this.options);
    this.registerType(this.options.source, this.options.type);
  },
  fetchData: function fetchData(query, caller) {
    caller.fetchSuccess(this.createQueryResult());
  },
  sq: function () {
    var _sq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query) {
      var queryResult, geometry, url, featureCollection, i, feature, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryResult = this.createQueryResult();

              if (!(query.wkt && query.wkt.indexOf('POINT') > -1)) {
                _context.next = 10;
                break;
              }

              geometry = this.translateWktToGeoJsonObject(query.wkt); //Voodoo to create plain object instead of terraformer - move to translateWktToGeoJsonObject?

              geometry = {
                type: geometry.type,
                coordinates: geometry.coordinates
              };
              geometry = this.toWgs84(geometry);
              url = this.buildUrl(geometry);
              _context.next = 8;
              return fetch2(url);

            case 8:
              featureCollection = _context.sent;

              for (i = featureCollection.features.length - 1; i > -1; i--) {
                feature = featureCollection.features[i];

                if (feature.geometry.coordinates.length > 0) {
                  feature.geometry = this.to25832(feature.geometry);
                  result = queryResult.addResult(this.options.source, this.options.type, this.secondsToHms(feature.properties.time) + 's ' + this.options.modetext, null, feature.geometry, feature);
                  result.distance = 0;
                }
              }

            case 10:
              return _context.abrupt("return", queryResult);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function sq(_x) {
      return _sq.apply(this, arguments);
    }

    return sq;
  }(),
  toWgs84: function toWgs84(geometry) {
    var crss = {
      "EPSG:25832": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
      "EPSG:4326": "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"
    };
    var toGeometry = reproject(geometry, "EPSG:25832", "EPSG:4326", crss);
    return toGeometry;
  },
  to25832: function to25832(geometry) {
    var crss = {
      "EPSG:25832": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
      "EPSG:4326": "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"
    };
    var toGeometry = reproject(geometry, "EPSG:4326", "EPSG:25832", crss);
    toGeometry = geojsonPrecision(toGeometry, 0);
    return toGeometry;
  },
  secondsToHms: function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    var hDisplay = "";
    if (h > 0) hDisplay = h + (h == 1 ? " time" : " timer");
    var mDisplay = "";

    if (m > 0) {
      if (h > 0) mDisplay = " ,";
      mDisplay += m + (m === 1 ? " minut" : " minutter");
    }

    var sDisplay = "";

    if (s > 0) {
      if (m > 0) sDisplay = " ,";
      sDisplay += s + (s === 1 ? " sekund" : " sekunder");
    }

    return hDisplay + mDisplay + sDisplay;
  },
  buildUrl: function buildUrl(geometry) {
    //http://fama.septima.dk:8080/otp/routers/denmark/isochrone?fromPlace=55.79153439014434,12.485555485973205&mode=CAR&date=11-14-2017&time=8:00am&precisionMeters=10&maxWalkDistance=10&cutoffSec=120&cutoffSec=240&cutoffSec=360&cutoffSec=480
    var reverseGeometry = reverse(geometry);
    var fromPlace = reverseGeometry.coordinates[0] + "," + reverseGeometry.coordinates[1];
    var cutoffSecParamValues = [];

    for (var i = 0; i < this.options.cutoffSecs.length; i++) {
      cutoffSecParamValues.push("cutoffSec=" + this.options.cutoffSecs[i]);
    }

    var cutoffSecsQueryString = cutoffSecParamValues.join('&');
    var url = "".concat(this.options.serviceUrl, "?fromPlace=").concat(fromPlace, "&mode=").concat(this.options.mode, "&date=").concat(this.options.date, "&time=").concat(this.options.time, "&precisionMeters=").concat(this.options.precisionMeters, "&maxWalkDistance=").concat(this.options.maxWalkDistance, "&").concat(cutoffSecsQueryString);
    return url;
  },
  CLASS_NAME: 'Septima.Search.IsoChroneSearcher'
});